import { daysRange } from 'app/constants/dates';

import { DvirHistoryState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const dvirHistoryState: DvirHistoryState = {
  equipments: null,
  driver: null,
  terminal: null,
  severity: null,
  dateRange: {
    fromDate: daysRange.minDay
      .startOf('day')
      .minus({ milliseconds: 1 })
      .toUTC()
      .toISO(),
    untilDate: daysRange.maxDay
      .endOf('day')
      .plus({ seconds: 1, milliseconds: 1 })
      .toUTC()
      .toISO(),
  },
  dvir: null,
  dvirUpdateDetails: null,
  base64stringMedia: '',
  sortBy: '-start_time',
  sortField: '-start_time',
  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,

  isToggleCertifyDvirModal: false,
  isToggleUpdateDetailsModal: false,
  isToggleMechanicSignatureModal: false,
  // Vehicle filter menu closed/open
  isVehicleFilterMenuClosed: false,
};
